import http from "@/utils/http";
import * as urls from "@/recourses/urls/pulse-bridge";
import type { PulseBridgeListResponse, PulseBridgeEntityResponse } from "@/types/pulse-bridge";

const bridgeGet = <T>(url: string, params: Record<string, string | number | undefined>) => {
  const endpoint = new URL(url);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) endpoint.searchParams.append(key, String(value));
  });
  return http.get<T>(endpoint.toString(), { isAuth: false });
};

export const getBuyAgainRecommendations = (customerId: number, storeId: number, limit = 20) =>
  bridgeGet<PulseBridgeListResponse>(urls.buyAgain(customerId), { store_id: storeId, channel: "online", limit });

export const getForYouRecommendations = (customerId: number, storeId: number, limit = 20) =>
  bridgeGet<PulseBridgeListResponse>(urls.forYou(customerId), { store_id: storeId, channel: "online", limit });

export const getTopProducts = (storeId: number, limit = 20) =>
  bridgeGet<PulseBridgeListResponse>(urls.topProducts, { store_id: storeId, channel: "online", limit });

export const getRelatedProducts = (productId: number | string, storeId: number, limit = 3) =>
  bridgeGet<PulseBridgeListResponse>(urls.relatedProducts(productId), {
    store_id: storeId,
    channel: "online",
    limit,
  });

export const getSimilarProducts = (productId: number | string, storeId: number, limit = 6) =>
  bridgeGet<PulseBridgeListResponse>(urls.similarProducts(productId), {
    store_id: storeId,
    channel: "online",
    limit,
    only_available: "true",
  });

export const getMostPurchasedCategory = (storeId: number, limit = 20) =>
  bridgeGet<PulseBridgeEntityResponse>(urls.mostPurchasedCategory, { store_id: storeId, channel: "online", limit });

export const getMostPurchasedHub = (storeId: number, limit = 20) =>
  bridgeGet<PulseBridgeEntityResponse>(urls.mostPurchasedHub, { store_id: storeId, channel: "online", limit });

export const getRecentlyViewedCustomer = (customerId: number, storeId: number, limit = 20) =>
  bridgeGet<PulseBridgeListResponse>(urls.recentlyViewedCustomer(customerId), { store_id: storeId, channel: "online", limit });

export const getRecentlyViewedSession = (sessionId: string, storeId: number, limit = 20) =>
  bridgeGet<PulseBridgeListResponse>(urls.recentlyViewedSession(sessionId), { store_id: storeId, channel: "online", limit });

export const getMostViewed = (storeId: number, limit = 20, days = 7) =>
  bridgeGet<PulseBridgeListResponse>(urls.mostViewed, { store_id: storeId, channel: "online", limit, days });

export const getFromViewsCustomer = (customerId: number, storeId: number, limit = 20) =>
  bridgeGet<PulseBridgeListResponse>(urls.fromViewsCustomer(customerId), { store_id: storeId, channel: "online", limit });

export const getFromViewsSession = (sessionId: string, storeId: number, limit = 20) =>
  bridgeGet<PulseBridgeListResponse>(urls.fromViewsSession(sessionId), { store_id: storeId, channel: "online", limit });

export const getNewProducts = (storeId: number, limit = 20) =>
  bridgeGet<PulseBridgeListResponse>(urls.topProducts, { store_id: storeId, channel: "online", limit, only_new: "true" });
